export const UMB_DATE_TIME_VALUE_SUMMARY_ALIAS = 'Umb.ValueSummary.DateTime' as const;
